var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paddingBox" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "rounded-box --whiteBg p-50" }, [
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.addZiak($event)
            }
          }
        },
        [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-12 col-md-12" }, [
              _c("label", { attrs: { for: "pridat-ziaka" } }, [
                _vm._v("Pridať žiaka do zoznamu")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "position-relative ziak-input-group" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.novyZiak,
                      expression: "novyZiak"
                    }
                  ],
                  staticClass: "form-control form-control-lg",
                  attrs: {
                    type: "text",
                    name: "pridat-ziaka",
                    id: "pridat-ziaka"
                  },
                  domProps: { value: _vm.novyZiak },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.novyZiak = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "btn --secondary", attrs: { type: "submit" } },
                  [_vm._v("pridať žiaka")]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-30" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between mb-15"
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v("Pridaných žiakov: "),
                    _c("b", { staticClass: "text-primary" }, [
                      _vm._v(_vm._s(this.form.pouzivatel_ziaci.length))
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "list-ziakov mb-0" },
                _vm._l(_vm.form.pouzivatel_ziaci, function(ziak, index) {
                  return _c("li", [
                    _c("p", { staticClass: "mb-0" }, [
                      _c("span", {
                        staticClass: "icon icon--user mr-15 text-icon"
                      }),
                      _c("b", [_vm._v(_vm._s(ziak))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass: "mb-0 remove-item cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.removeZiak(index)
                          }
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "text-primary text-underline" },
                          [_vm._v("Odstrániť žiaka")]
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "icon icon--delete text-primary ml-10"
                        })
                      ]
                    )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "form-row mb-0" }, [
            _c("div", { staticClass: "col-12 col-md-12 text-right" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "text-primary text-underline cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.$emit("updateStep", "kolektiv")
                        }
                      }
                    },
                    [_vm._v("Späť na prvý krok")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn --primary",
                      attrs: { disabled: !_vm.form.pouzivatel_ziaci.length },
                      on: {
                        click: function($event) {
                          return _vm.$emit("updateStep", "zhrnutie")
                        }
                      }
                    },
                    [_vm._v("pokračovať na zhrnutie")]
                  )
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "d-flex align-items-center justify-content-between mb-20"
      },
      [_c("h2", { staticClass: "mb-0" }, [_vm._v("Zoznam žiakov")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-uppercase mb-0" }, [
      _c("b", { staticClass: "text-dark" }, [_vm._v("zoznam pridaných žiakov")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "separator" })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }